'use client';
import { cleanHTML } from '@repo/utils';
import { useEffect, useState } from 'react';

/**
 * Renders backend HTML (terms and conditions) once sanitized. cleanHTML needs the DOM and returns nothing on the server,
 * so the HTML goes in after mounting: rendering it straight away broke hydration of server rendered steps.
 *
 * @param {string} [html] - The HTML to sanitize and render.
 * @return {React.JSX.Element} The sanitized HTML.
 */
export const SanitizedHtml = ({ html }: { html?: string }): React.JSX.Element => {
  const [sanitized, setSanitized] = useState('');
  useEffect(() => {
    setSanitized(cleanHTML(html || ''));
  }, [html]);
  return <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
